import React from 'react'
import noop from 'lib/function/noop'
import LuxKitModalBehaviourState, { LuxKitModalBehaviourDispatchAction, MODAL_BEHAVIOUR_INITIAL_STATE } from './LuxKitModalBehaviourState'

export const LuxKitModalBehaviourStateContext = React.createContext<LuxKitModalBehaviourState>(MODAL_BEHAVIOUR_INITIAL_STATE)
export const LuxKitModalBehaviourDispatchContext = React.createContext<React.Dispatch<LuxKitModalBehaviourDispatchAction>>(noop)
